import varAxios from "../../Comman/axios";
import {GetAllEmailSettingsUrl, UpdateApplicationRejectionUrl,
    UpdateApprovalTimeUrl, UpdateForgotPasswordUrl, UpdateRegistrationTimeUrl,
    UpdateSupportEmailUrl,UpdateAcknowledgeEmailUrl, getApplicationLogoUrl, addApplicationLogoUrl,
    addSubjectUrl, getSubjectListUrl, updateSubjectUrl, deleteSubjectUrl,
    getSimpleMailTransferProtocolListURL, UpdateSimpleMailTransferProtocolUrl} from '../../Comman/apiEndPoints';

export const Fetch_Email_Setting_Success_Data = "Fetch_Email_Setting_Success_Data";
export const Update_Email_Setting_Success_Data = "Update_Email_Setting_Success_Data";

export const ADD_SUBJECT_REQUEST = "ADD_SUBJECT_REQUEST";
export const ADD_SUBJECT_SUCCESS = "ADD_SUBJECT_SUCCESS";
export const GET_SUBJECT_REQUEST = "GET_SUBJECT_REQUEST";
export const GET_SUBJECT_SUCCESS = "GET_SUBJECT_SUCCESS";
export const SMTP_REQUEST = "SMTP_REQUEST";
export const SMTP_SUCCESS = "SMTP_SUCCESS";
export const UPDATE_SMTP_SUCCESS = "UPDATE_SMTP_SUCCESS";
export const APPLICATION_REQUEST = "APPLICATION_REQUEST";
export const APPLICATION_SUCCESS = "APPLICATION_SUCCESS";
export const ADD_APPLICATION_SUCCESS = "ADD_APPLICATION_SUCCESS";

export function getAllEmailSettings() {
   return(dispatch) =>{
      return varAxios.get(GetAllEmailSettingsUrl)
      .then(response => {
         dispatch(
            fetchEmailSettingSuccessData({
               errorCode : response.data.errorCode,
               statusCode : response.data.statusCode,
               emailSettingList : response.data.EmailSetting
            }));
      })
      .catch((error) => {
         console.log("error",error);
     })
   }   
}
export function fetchEmailSettingSuccessData({errorCode,statusCode,emailSettingList}) {
    return {
        type : Fetch_Email_Setting_Success_Data,
        errorCode,
        statusCode,
        emailSettingList
    }
}
export function updateDataSuccess(errorCode,statusCode,updatedList) {
    return {
      type : Update_Email_Setting_Success_Data,
      errorCode,
      statusCode,
      updatedList
    }
}
export function updateApplicationRejection(subject,body) {
    let requestPayload = {
        EmailSubject : subject,
        EmailBody : body
    }
    return (dispatch) => {
        return varAxios.put(UpdateApplicationRejectionUrl, requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              if(response.data.statusCode == 200){
                dispatch(
                  updateDataSuccess(response.data.errorCode,response.data.statusCode,
                    response.data.EmailSetting)
                );
              }
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function updateApprovalTime(subject,body) {
    let requestPayload = {
        EmailSubject : subject,
        EmailBody : body
    }
    return (dispatch) => {
        return varAxios.put(UpdateApprovalTimeUrl, requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              if(response.data.statusCode == 200){
                dispatch(
                  updateDataSuccess(response.data.errorCode,response.data.statusCode,
                    response.data.EmailSetting)
                );
              }
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function updateForgotPassword(subject,body) {
    let requestPayload = {
        EmailSubject : subject,
        EmailBody : body
    }
    return (dispatch) => {
        return varAxios.put(UpdateForgotPasswordUrl, requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              if(response.data.statusCode == 200){
                dispatch(
                  updateDataSuccess(response.data.errorCode,response.data.statusCode,
                    response.data.EmailSetting)
                );
              }
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function updateRegistrationTime(subject,body) {
    let requestPayload = {
        EmailSubject : subject,
        EmailBody : body
    }
    return (dispatch) => {
        return varAxios.put(UpdateRegistrationTimeUrl, requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              if(response.data.statusCode == 200){
                dispatch(
                  updateDataSuccess(response.data.errorCode,response.data.statusCode,
                    response.data.EmailSetting)
                );
              }
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function updateSupport(subject,body) {
    let requestPayload = {
        EmailSubject : subject,
        EmailBody : body
    }
    return (dispatch) => {
        return varAxios.put(UpdateSupportEmailUrl, requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              if(response.data.statusCode == 200){
                dispatch(
                  updateDataSuccess(response.data.errorCode,response.data.statusCode,
                    response.data.EmailSetting)
                );
              }
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function updateAcknowledge(subject,body) {
    let requestPayload = {
        EmailSubject : subject,
        EmailBody : body
    }
    return (dispatch) => {
        return varAxios.put(UpdateAcknowledgeEmailUrl, requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              if(response.data.statusCode == 200){
                dispatch(
                  updateDataSuccess(response.data.errorCode,response.data.statusCode,
                    response.data.EmailSetting)
                );
              }
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function addSubjectFunc(payload) {
    return (dispatch) => { 
      dispatch(addSubjectRequest(true)); 
        return varAxios.post(addSubjectUrl, payload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              dispatch(
                addSubjectSuccess(false,response.data.errorCode,response.data.statusCode,
                  response.data.Message)
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }

  export function addSubjectRequest(isLoading){
    return {
      type : ADD_SUBJECT_REQUEST,
      isLoading
    }
  }
  export function addSubjectSuccess(isLoading,errorCode, statusCode, message){
    return {
      type : ADD_SUBJECT_SUCCESS,
      isLoading,
      errorCode,
      statusCode,
      message
    }
  }
  export function getSubjectFunc() {
    return (dispatch) => {
      dispatch(getSubjectRequest(true)); 
        return varAxios.get(getSubjectListUrl)
            .then((response) => {
              dispatch(
                getSubjectSuccess(false,response.data.errorCode,response.data.statusCode,
                  response.data.customSubjectList)
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function getSubjectRequest(isLoading){
    return {
      type : GET_SUBJECT_REQUEST,
      isLoading
    }
  }
  export function getSubjectSuccess(isLoading,errorCode, statusCode, list){
    return {
      type : GET_SUBJECT_SUCCESS,
      isLoading,
      errorCode,
      statusCode,
      list
    }
  }


  export function getSMTPFunc() {
    return (dispatch) => {
      dispatch(SMTPRequest(true)); 
        return varAxios.get(getSimpleMailTransferProtocolListURL)
            .then((response) => {
              dispatch(
                SMTPSuccess(false,response.data.errorCode,response.data.statusCode,
                  response.data.mailTransferProtocol)
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function SMTPRequest(isLoading){
    return {
      type : SMTP_REQUEST,
      isLoading
    }
  }
  export function SMTPSuccess(isLoading,errorCode, statusCode, mailTransferProtocol){
    return {
      type : SMTP_SUCCESS,
      isLoading,
      errorCode,
      statusCode,
      mailTransferProtocol
    }
  }

  export function addSMTPFunc(payload) {
    return (dispatch) => {
      dispatch(SMTPRequest(true)); 
        return varAxios.post(UpdateSimpleMailTransferProtocolUrl, payload)
            .then((response) => {
              dispatch(
                updateSMTPSuccess(false,response.data.errorCode,response.data.statusCode,
                  response.data.Message)
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function updateSMTPSuccess(isLoading,errorCode, statusCode, Message){
    return {
      type : UPDATE_SMTP_SUCCESS,
      isLoading,
      errorCode,
      statusCode,
      Message
    }
  }

  export function deleteSubjectFunc(payload) {
    return (dispatch) => { 
      dispatch(addSubjectRequest(true)); 
        return varAxios.post(deleteSubjectUrl, payload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              dispatch(
                addSubjectSuccess(false,response.data.errorCode,response.data.statusCode,
                  response.data.Message)
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }

  export function updateSubjectFunc(payload) {
    return (dispatch) => { 
      dispatch(addSubjectRequest(true)); 
        return varAxios.post(updateSubjectUrl, payload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              dispatch(
                addSubjectSuccess(false,response.data.errorCode,response.data.statusCode,
                  response.data.Message)
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }

  export function getApplicationLogo() {
    return (dispatch) => {
      dispatch(ApplicationRequest(true)); 
        return varAxios.get(getApplicationLogoUrl)
            .then((response) => {
              debugger
              dispatch(
                ApplicationLogoSuccess(false,response.data.errorCode,response.data.statusCode,
                  response.data.emailLogo)
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function ApplicationRequest(isLoading){
    return {
      type : APPLICATION_REQUEST,
      isLoading
    }
  }
  export function ApplicationLogoSuccess(isLoading,errorCode, statusCode, emailLogoData){
    debugger
    return {
      type : APPLICATION_SUCCESS,
      isLoading,
      errorCode,
      statusCode,
      emailLogoData
    }
  }
  export function addApplicationLogo(payload) {
    return (dispatch) => { 
      dispatch(ApplicationRequest(true)); 
        return varAxios.post(addApplicationLogoUrl, payload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              dispatch(
                addApplicationSuccess(false,response.data.errorCode,response.data.statusCode,
                  response.data.Message)
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function addApplicationSuccess(isLoading,errorCode, statusCode, Message){
    return {
      type : ADD_APPLICATION_SUCCESS,
      isLoading,
      errorCode,
      statusCode,
      Message
    }
  }